<template>
  <div>
    <v-card class="defaultCardClass pb-4">
      <!-- User Information -->
      <v-card-title>
        <v-layout align-center row wrap style="position: relative">
          <feed-post-header :itemData="itemData" />
        </v-layout>
      </v-card-title>

      <!-- Content Detail -->
      <v-layout fill-height row wrap mx-4 mb-3>
        <v-flex xs12>
          <!-- Title -->
          <v-layout
            row
            wrap
            class="overflow-x-hidden pr-3 mt-0"
            style="line-height: 20px; word-wrap: break-word"
          >
            <h4
              style="font-size: 18px; overflow-y: hidden"
              :class="`hover-underline colorBlack1`"
              @click="$router.push({ path: `/surveyDetail/${itemData.Id}`})"
            >
              {{ itemData.Type != "Link" ? itemData.Question : itemData.Name }}
            </h4>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-divider class="mx-3 mt-1" />

      <!-- Şıklar -->
      <v-card-text class="my-3">
        <v-layout row wrap align-center px-2>
          <!-- Links -->
          <div v-if="itemData.Type == 'Link'">
            <h4
              style="font-size: 16px"
              @click="openLink(itemData.Question)"
              :class="`hover-underline light-blue--text font-weight-medium`"
            >
              {{ $t("buttons.goToLink") }}
            </h4>
          </div>

          <!-- Multi Choice and Single Choice-->
          <div
            v-if="
              itemData.Type == 'Multi Choice' ||
              itemData.Type == 'Single Choice'
            "
          >
            <v-radio-group
              v-if="itemData.Type == 'Single Choice'"
              v-model="answerModel"
              :readonly="buttonDisabledStatus"
              :disabled="buttonDisabledStatus"
              :multiple="itemData.Type == 'Multi Choice' ? true : false"
            >
              <v-radio
                v-for="option in itemData.Options"
                :key="option.OptionId"
                :label="option.Text"
                class="my-2"
                :value="option.Text"
              ></v-radio>
            </v-radio-group>

            <v-checkbox
              v-for="option in itemData.Options"
              v-if="itemData.Type == 'Multi Choice'"
              :readonly="buttonDisabledStatus"
              :disabled="buttonDisabledStatus"
              v-model="answerModel"
              :key="option.OptionId"
              :label="option.Text"
              class="my-2"
              :value="option.Text"
            ></v-checkbox>
          </div>

          <!-- Open-ended -->
          <v-layout
            v-if="itemData.Type == 'Open-ended'"
            row
            wrap
            align-center
            my-2
          >
            <v-textarea
              v-model.trim="answerModel"
              class="px-2 mr-2"
              rows="4"
              style="border-width: 1rem"
              :disabled="buttonDisabledStatus"
              outlined
              hide-details
              full-width
              :placeholder="$t('placeHolder.answer')"
            >
            </v-textarea>
          </v-layout>
        </v-layout>
      </v-card-text>

      <!-- Buttons -->
      <v-layout
        align-center
        justify-center
        row
        wrap
        mx-4
        mb-4
        mt-0
        v-if="itemData.Type != 'Link'"
      >
        <v-btn
          color="defaultColor"
          class="white--text text-capitalize mr-3"
          elevation="0"
          rounded
          large
          :disabled="buttonDisabledStatus"
          @click="answerSurvey"
        >
          {{ getButtonTitle() }}
        </v-btn>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import FeedPostHeader from "../Feeds/FeedPostHeader.vue";
import SurveyService from "../../services/SurveyService";

export default {
  expose: ["buttonDisabled"],
  data() {
    return {
      answerModel: [],
      buttonDisabledStatus: false,
    };
  },

  props: {
    itemData: {
      type: Object,
      required: true,
    },
    answerData: {
      type: Array,
      required: true,
    },
  },

  components: {
    FeedPostHeader,
  },

  mounted() {
    this.answeredSurvey();
  },

  methods: {
    answerSurvey() {
      let _answer = "";
      if (this.itemData.Type === "Multi Choice") {
        _answer = this.answerModel.join("|");
      } else {
        _answer = this.answerModel;
      }

      const body = {
        SurveyId: this.itemData.Id,
        Answer: _answer,
      };
      SurveyService.setAnswerSurvey(body)
        .then((res) => {
          showSuccess(this.$t("description.successAnswerSurvey"));
          this.setAnswer(body);
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {});
    },

    setAnswer(body) {
      this.answerData.push(body);
      this.buttonDisabledStatus = true;
    },

    answeredSurvey() {
      let answered = this.answerData.find(
        (x) => x.SurveyId == this.itemData.Id
      );
      if (answered && !this.answerModel.length > 0) {
        if (this.itemData.Type == "Open-ended") {
          this.answerModel = answered.Answer;
        } else if (this.itemData.Type == "Multi Choice") {
          let abc = answered.Answer.split("|");
          this.answerModel = abc;
        } else if (this.itemData.Type == "Single Choice") {
          this.answerModel = answered.Answer;
        }
        this.buttonDisabledStatus = true;
      }
    },

    getButtonTitle() {
      let buttonText = this.buttonDisabledStatus
        ? this.$t("buttons.answeredSurvey")
        : this.$t("buttons.answerSurvey");
      return buttonText;
    },
  },

  computed: {},
};
</script>

<style></style>
